<template>
  <div class="h-auto md:pt-6 pb-20 ltr:ml-2 rtl:mr-2 minMaxTablet:!mx-0">
    <div class="w-[99%] bg-white rounded-md shadow-ts1 mb-24 md:mx-2 relative minMaxTablet:!w-full minMaxTablet:!mx-0" id="taContainer">
      <div class="p-5 border-b border-gray-400">
        <h2 class="font-display text-xl font-bold text-blue leading-none">{{ $t('account_list').tTitle() }}</h2>
      </div>

      <div class="flex flex-wrap justify-between p-6 px-5">
        <!-- <div class="w-auto inline-block relative order-1">
          <select v-model="selectedPlatform" name="platform"
            class="rtl:bg-left bg-none ltr:pl-4 rtl:pr-4 ltr:pr-12 rtl:pl-12 py-3 bg-white text-blue border border-gray-300 border-solid rounded-md text-base font-bold focus:border focus:border-gray-300 focus:border-solid focus:outline-none focus:ring-0 cursor-pointer">
            <option value="all">{{ $t('platform').tTitle() }}</option>
            <option value="mt4">MT4</option>
            <option value="mt5">MT5</option>
            <option value="pamm">PAMM</option>
            <option value="trl">Tradelocker</option>
          </select>
          <div class="select-arrow">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
              <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
            </svg>
          </div>
        </div> -->
        <Select v-model="selectedPlatform" name="platform" placeholder="platform" :options="platforms" :InputContainerClass="'w-[48%] max-w-40 l150:w-auto l150:!max-w-none'" :mode="'secondary'"/>

        <div class="flex w-full l150:w-[370px] mt-12 l150:mt-1 order-last l150:order-2">
          <ButtonGroup :options="['all', 'live', 'demo']" :selectedOption="selectedAccountType"
            @click="(opt) => selectedAccountType = opt" />
        </div>
        <div class="flex w-[48%] !max-w-40 l150:w-auto l150:!max-w-none gap-4 order-3 items-center">
          <div class="w-20 h-7 border border-gray-300 border-solid rounded-[21px] hidden l150:flex">
            <div @click="selectedView = 'list'" :class="[selectedView == 'list' ? 'bg-blue bg-opacity-15' : '']"
              class="w-1/2 flex flex-col justify-center items-center ltr:rounded-l-[21px] rtl:rounded-r-[21px] cursor-pointer">
              <span :class="[selectedView == 'list' ? 'bg-blue' : 'bg-[#C9C9C9]']"
                class="h-[1px] w-4 mb-1 table"></span>
              <span :class="[selectedView == 'list' ? 'bg-blue' : 'bg-[#C9C9C9]']"
                class="h-[1px] w-4 mb-1 table"></span>
              <span :class="[selectedView == 'list' ? 'bg-blue' : 'bg-[#C9C9C9]']" class="h-[1px] w-4 table"></span>
            </div>
            <div @click="selectedView = 'grid'" :class="[selectedView == 'grid' ? 'bg-blue bg-opacity-15' : '']"
              class="w-1/2 flex flex-col justify-center items-center ltr:rounded-r-[21px] rtl:rounded-l-[21px] cursor-pointer">
              <div class="flex gap-0.5 mb-0.5">
                <div :class="[selectedView == 'grid' ? 'border-blue' : 'border-[#C9C9C9]']"
                  class="w-[7px] h-[7px] rounded-[2px] border border-solid"></div>
                <div :class="[selectedView == 'grid' ? 'border-blue' : 'border-[#C9C9C9]']"
                  class="w-[7px] h-[7px] rounded-[2px] border border-solid"></div>
              </div>
              <div class="flex gap-0.5">
                <div :class="[selectedView == 'grid' ? 'border-blue' : 'border-[#C9C9C9]']"
                  class="w-[7px] h-[7px] rounded-[2px] border border-solid"></div>
                <div :class="[selectedView == 'grid' ? 'border-blue' : 'border-[#C9C9C9]']"
                  class="w-[7px] h-[7px] rounded-[2px] border border-solid"></div>
              </div>
            </div>
          </div>
          <Button @click="showCAModal()" customClasses="order-3">
            {{ $t('create_account') }}
          </Button>
        </div>
      </div>

      <!-- Grid Layout -->
      <div v-if="selectedView == 'grid'"
        class="flex flex-wrap justify-center lg:justify-start mx-5 lg:mx-6 pb-3.5 minMaxTablet:grid minMaxTablet:grid-cols-[repeat(auto-fill,minmax(280px,1fr))] minMaxTablet:gap-[23px] minMaxTablet:!mx-5 minMaxTablet:pb-6">
        <div v-for="item in filteredTradingAccounts" :key="item.external_id" :id="item.external_id"
          class="w-full max-w-80 flex-shrink-0 mx-[11px] ltr:lg:ml-0 rtl:lg:mr-0 ltr:lg:mr-[23px] rtl:lg:ml-[23px] mb-[23px] pt-2.5 rounded-lg border border-gray-300 border-solid minMaxTablet:!max-w-none minMaxTablet:!m-0">
          <div class="p-4 relative noUserSelect"
            :class="[item.account_type == '' || item.account_type.toLowerCase() == 'archived' ? 'opacity-60' : '']">
            <div v-if="item.account_type.toLowerCase().includes('slave of')"
              class="absolute -top-5 right-4 h-5 px-2.5 flex justify-center items-center bg-[#F0F3FF] border border-[#D3D3D3] border-solid rounded-xl text-[9px] text-gray-900 font-medium">
              {{ item.account_type.toLowerCase().replace('slave of', $t('attached_to')) }}
            </div>
            <div
              v-if="item.copy_trading_following_providers.length>0"
              class="absolute -top-5 right-4 h-5 px-2.5 flex justify-center items-center bg-[#F0F3FF] dark:bg-surface border border-[#D3D3D3] dark:border-divider border-solid rounded-xl text-[9px] text-gray-900 dark:text-white font-medium"
            >
              <div v-if="item.copy_trading_following_providers.length > 2">
                <span>{{ $t('copying') }} </span>
                <span
                  v-for="(provider, index) in item.copy_trading_following_providers.slice(0, 2)"
                  :key="provider.provider_id"
                >
                  <span
                    :class="provider.activated ? 'text-green' : 'text-red-500'"
                  >
                    {{ provider.provider_external_id }}
                  </span>

                  <span
                    v-if="index < item.copy_trading_following_providers.slice(0, 2).length - 1"
                  >
                    ,
                  </span>
                </span>
                <img
                  @click="showCopyTradingAttachedToTooltip = !showCopyTradingAttachedToTooltip"
                  src="../../assets/img/plus-icon.svg"
                  class="relative overflow-visible float-right h-3 w-3 cursor-pointer maxXs:mb-auto ml-1"
                />
                <div
                  v-if="showCopyTradingAttachedToTooltip"
                  class="min-w-[138px] w-auto max-w-xs absolute ltr:left-[-2px] right-[-2px] rtl:right-0 top-[-1px] px-2.5 py-[3px] bg-gray-400 dark:bg-surface border border-[#D3D3D3] dark:border-divider rounded-xl z-20"
                >
                  <img
                    @click="showCopyTradingAttachedToTooltip = !showCopyTradingAttachedToTooltip"
                    src="../../assets/img/minus-icon.svg"
                    class="relative overflow-visible float-right h-3 w-3 cursor-pointer maxXs:mb-auto ml-1"
                  />
                  <p class="text-[9px] text-primary-text font-medium">
                    <span>{{ $t('copying') }} </span>

                    <span
                      v-for="(provider, index) in item.copy_trading_following_providers"
                      :key="provider.provider_id"
                    >
                      <span
                        :class="provider.activated ? 'text-green-500' : 'text-red-500'"
                      >
                        {{ provider.provider_external_id }}
                      </span>

                      <span
                        v-if="index < item.copy_trading_following_providers.length - 1"
                      >,</span>
                    </span>
                  </p>
                </div>
              </div>
              <div v-else>
                <span>{{ $t('copying') }} </span>

                <span
                  v-for="(provider, index) in item.copy_trading_following_providers"
                  :key="provider.provider_id"
                >
                  <span
                    :class="provider.activated ? 'text-green-500' : 'text-red-500'"
                  >
                    {{ provider.provider_external_id }}
                  </span>

                  <span
                    v-if="index < item.copy_trading_following_providers.length - 1"
                  >,</span>
                </span>
              </div>
            </div>
            <div class="flex mb-4">
              <img v-if="getItemImage(item)" class="h-[60px] w-[60px] m-auto" :src="getItemImage(item)" />
              <div class="w-full">
                <div class="flex justify-between items-center">
                  <div :class="[item.type == 'live' ? 'bg-green' : 'bg-gray-900']"
                    class="h-5 text-white text-xs font-medium rounded-xl px-5 ltr:ml-4 rtl:mr-4 pt-0.5 inline-block">
                    {{ item.type.tTitle() }}
                  </div>
                  <div v-if="item.account_type != '' && item.account_type.toLowerCase() != 'archived'"
                    @click="showActionsTooltip(item.external_id)"
                    class="tooltip-icon h-7 w-7 bg-white hover:bg-gray-400 text-center rounded-full transition-all duration-300 ease-in-out text-2xl text-gray-900 leading-4 cursor-pointer">
                    ...
                  </div>
                </div>
                <p class="text-gray-900 font-bold text-xl ltr:ml-4 rtl:mr-4">{{ item.external_id }}</p>
                <p class="text-gray-900 text-[11px] ltr:ml-4 rtl:mr-4 font-medium">
                  {{
                  item.account_type == ''
                  ? $t('archived')
                  : item.account_type_identifier == 'silver-islamic'
                  ? 'Islamic'
                  : item.account_type_identifier == 'pamm-master'
                  ? 'Master'
                  : item.account_type_identifier == 'pamm-investor'
                  ? 'Investor'
                  : item.account_type
                  }}
                  / {{ item.platform == 'mt4' ? 'MetaTrader 4' : item.platform == 'mt5' ? 'MetaTrader 5' : item.platform
                  == 'trl' ? 'Tradelocker' : 'PAMM' }}
                </p>
              </div>
            </div>
            <div class="w-full rounded-lg bg-blue bg-opacity-15 px-4 py-1.5 mb-3.5">
              <p class="text-gray-900 text-sm leading-6 font-medium">{{ $t('account_balance').tTitle() }}</p>
              <p class="text-blue font-bold text-4xl mt-[-3px]">{{ $formatMoney(item.balance,
                currencySymbols[item.currency]) }}</p>
            </div>
            <div class="w-full flex space-x-3.5 rtl:space-x-reverse">
              <div class="w-1/2 rounded-lg bg-blue bg-opacity-15">
                <p class="text-gray-900 text-sm leading-6 font-medium pt-1 ltr:pl-4 rtl:pr-4">{{ $t('equity').tTitle()
                  }}</p>
                <p class="text-blue font-medium text-base ltr:pl-4 rtl:pr-4 pb-1 leading-6">{{ $formatMoney(item.equity,
                  currencySymbols[item.currency]) }}</p>
              </div>
              <div class="w-1/2 rounded-lg bg-blue bg-opacity-15">
                <p class="text-gray-900 text-sm leading-6 font-medium pt-1 ltr:pl-4 rtl:pr-4">{{ $t('leverage').tTitle()
                  }}</p>
                <p class="text-blue font-medium text-base ltr:pl-4 rtl:pr-4 pb-1 leading-6">1:{{ item.leverage }}</p>
              </div>
            </div>
            <div :class="[!item.accept_bonus ? 'bg-[#e0e1e4]' : 'bg-[#def4ec]']"
              class="w-full rounded-lg flex gap-1 px-4 py-2 mt-3.5">
              <p class="text-gray-900 text-sm font-semibold">{{ $t('bonus_120') }}:</p>
              <p class="text-gray-900 font-medium text-sm">{{ !item.accept_bonus ? $t('no_bonus') :
                getTABonus(item.external_id) }}</p>
            </div>
            <div class="w-full mt-3.5">
              <Button v-if="item.transfer_locked && item.transfer_account_external_id!=''" mode="secondary" size="small" customClasses="!font-bold !py-1 h-[30px]" @click="openTransferBackModal(item.external_id, item.equity)" :disabled="item.account_type=='' || item.account_type.toLowerCase()=='archived'">
                {{ $t('transfer').tTitle() }}
              </Button>
              <Button v-else mode="secondary" size="small" customClasses="!font-bold !py-1 h-[30px]" :disabled="item.account_type == '' || item.account_type.toLowerCase() == 'archived'">
                <router-link :to="'/' + Language + '/finance'">
                  {{ $t('deposit').tTitle() }}
                </router-link>
              </Button>
            </div>

            <div
              v-if="item.account_type != '' && item.account_type.toLowerCase() != 'archived'"
              class="actions-tooltip absolute top-[3.4rem] ltr:right-6 rtl:left-6 bg-white border border-gray-300 border-solid shadow-ts1 rounded-lg px-3 py-5 w-[240px] "
              :class="{ hidden: activeMobileTooltip !== item.external_id }"
              @click="closeActionsTooltip"
            >
            <Button v-if="item.account_type_identifier != 'pamm-investor'" @click="(activeMobileTooltip = null), (changeTAPassword.TAID = item.external_id), (changeTAPassword.modalActive = true)" mode="primary-white" customClasses="leading-6 !font-normal !py-2 table mb-2">
                 {{ $t('change_password').tTitle() }}
            </Button>
            <Button v-if="item.account_type_identifier != 'pamm-investor'" mode="primary-white" customClasses="leading-6 !font-normal !py-2 table mb-2">
              <router-link :to="'/' + Language + '/trading-account/download'" @click="activeMobileTooltip = null">
                {{ $t('platforms').tTitle() }}
              </router-link>
            </Button>
            <Button v-if="item.platform=='mt4' || item.platform=='mt5' || item.platform == 'trl'" mode="primary-white" customClasses="leading-6 !font-normal !py-2 table mb-2">
              <a
                :href="[item.platform=='mt4'? mt4WebTraderLinks: item.platform=='mt5'? mt5WebTraderLinks:'https://live.tradelocker.com/auth/login']"
                target="_blank"
                @click="activeMobileTooltip = null">
                {{ item.platform == 'trl' ? $t('launch_tradelocker').tTitle() : $t('launch_webtrader').tTitle() }}
              </a>
            </Button>
            <Button
              mode="primary-white"
              customClasses="leading-6 !font-normal !py-2 table"
              @click="(activeMobileTooltip = null), $refs.viewTradesModal.openModal(item.external_id, item.platform, item.type)">
                {{ $t('view_trades').tTitle() }}
            </Button>
              <!-- <a
                v-if="item.account_type_identifier=='pamm-investor' || item.account_type_identifier=='pamm-master'"
                href="https://pamm.plexytrade.com/"
                target="_blank"
                class="w-full hover:bg-blue rounded-md text-gray-900 hover:text-white text-center appearance-none py-2 text-base leading-6 mt-2 table"
              >{{$t('pamm_dashboard').tTitle()}}</a> -->
            <Button
              v-if="item.account_type_identifier == 'copy-trading-provider' || item.account_type_identifier == 'copy-trading-follower'"
              mode="primary-white" customClasses="leading-6 !font-normal !py-2 table my-2"
              @click="(activeMobileTooltip = null)">
              <a
                href="https://social-trading.plexytrade.com/"
                target="_blank"
                @click="activeTooltip = null">
                {{ $t('copy_trading_dashboard_link').tTitle() }}
              </a>
            </Button>
            <Button
              mode="primary-white"
              customClasses="leading-6 !font-normal !py-2"
              v-if="item.type === 'demo'"
              @click="(activeMobileTooltip = null), openEditDemoBalanceModal(User.info.ID, item.external_id, item.balance, currencySymbols[item.currency])"
            >
              {{ $t('edit').tTitle() }}
            </Button>
            </div>
          </div>
        </div>
      </div>
      <!-- List/Table Layout -->
      <div v-else-if="selectedView == 'list'" class="hidden md:block mx-6 pb-6 select-none" id="taListContainer"
        :class="{ 'overflow-auto lg:pb-20': filteredTradingAccounts.length > 0 }">
        <table cellpadding="0" cellspacing="0" class="w-full border-separate min-w-[1050px] whitespace-nowrap"
          style="border-spacing: 0 16px">
          <tr v-for="item in filteredTradingAccounts" :key="item.external_id" :id="item.external_id" class="w-full h-20"
            :class="[item.account_type == '' || item.account_type.toLowerCase() == 'archived' ? 'opacity-60' : '']">
            <td
              class="w-[76px] ltr:lg:pl-4 rtl:lg:pr-4 ltr:2xl:pl-5 rtl:2xl:pr-5 border-y ltr:border-l rtl:border-r border-gray-300 border-solid ltr:rounded-l-lg rtl:rounded-r-lg"
              v-if="getItemImage(item)">
              <img v-if="getItemImage(item)" class="h-[60px] w-full m-auto" :src="getItemImage(item)" />
            </td>
            <td class="border-y border-gray-300 border-solid pl-4 pr-3 relative"
              :class="{ 'ltr:border-l rtl:border-r': !getItemImage(item) }">
              <div v-if="item.account_type.toLowerCase().includes('slave of')"
                class="absolute -top-2.5 left-0 h-5 px-2.5 flex justify-center items-center bg-[#F0F3FF] border border-[#D3D3D3] border-solid rounded-xl text-[9px] text-gray-900 font-medium">
                {{ item.account_type.toLowerCase().replace('slave of', $t('attached_to')) }}
              </div>
              <div
                v-if="item.copy_trading_following_providers.length>0"
                class="absolute -top-2.5 right-4 h-5 px-2.5 flex justify-center items-center bg-[#F0F3FF] dark:bg-surface border border-[#D3D3D3] dark:border-divider border-solid rounded-xl text-[9px] text-gray-900 dark:text-white font-medium"
              >
                <div v-if="item.copy_trading_following_providers.length > 2">
                  <span>{{ $t('copying') }} </span>
                  <span
                    v-for="(provider, index) in item.copy_trading_following_providers.slice(0, 2)"
                    :key="provider.provider_id"
                  >
                    <span
                      :class="provider.activated ? 'text-green' : 'text-red-500'"
                    >
                      {{ provider.provider_external_id }}
                    </span>

                    <span
                      v-if="index < item.copy_trading_following_providers.slice(0, 2).length - 1"
                    >
                      ,
                    </span>
                  </span>
                  <img
                    @click="showCopyTradingAttachedToTooltip = !showCopyTradingAttachedToTooltip"
                    src="../../assets/img/plus-icon.svg"
                    class="relative overflow-visible float-right h-3 w-3 cursor-pointer maxXs:mb-auto ml-1"
                  />
                  <div
                    v-if="showCopyTradingAttachedToTooltip"
                    class="min-w-[138px] w-auto max-w-xs absolute ltr:left-[-2px] right-[-2px] whitespace-normal rtl:right-0 top-[-1px] px-2.5 py-[3px] bg-gray-400 dark:bg-surface border border-[#D3D3D3] dark:border-divider rounded-xl z-20"
                  >
                    <img
                      @click="showCopyTradingAttachedToTooltip = !showCopyTradingAttachedToTooltip"
                      src="../../assets/img/minus-icon.svg"
                      class="relative overflow-visible float-right h-3 w-3 cursor-pointer maxXs:mb-auto ml-1"
                    />
                    <p class="text-[9px] text-primary-text font-medium">
                      <span>{{ $t('copying') }} </span>

                      <span
                        v-for="(provider, index) in item.copy_trading_following_providers"
                        :key="provider.provider_id"
                      >
                        <span
                          :class="provider.activated ? 'text-green-500' : 'text-red-500'"
                        >
                          {{ provider.provider_external_id }}
                        </span>

                        <span
                          v-if="index < item.copy_trading_following_providers.length - 1"
                        >,</span>
                      </span>
                    </p>
                  </div>
                </div>
                <div v-else>
                  <span>{{ $t('copying') }} </span>

                  <span
                    v-for="(provider, index) in item.copy_trading_following_providers"
                    :key="provider.provider_id"
                  >
                    <span
                      :class="provider.activated ? 'text-green-500' : 'text-red-500'"
                    >
                      {{ provider.provider_external_id }}
                    </span>

                    <span
                      v-if="index < item.copy_trading_following_providers.length - 1"
                    >,</span>
                  </span>
                </div>
              </div>
              <p class="text-gray-900 ltr:text-left rtl:text-right font-bold text-lg leading-5 text-center pb-1">
                {{
                item.account_type == ''
                ? $t('archived')
                : item.account_type_identifier == 'silver-islamic'
                ? 'Islamic'
                : item.account_type_identifier == 'pamm-master'
                ? 'Master'
                : item.account_type_identifier == 'pamm-investor'
                ? 'Investor'
                : item.account_type_identifier == 'no-deposit-bonus'
                ? 'NDB'
                : item.account_type
                }}
              </p>
              <div :class="[item.type == 'live' ? 'bg-green' : 'bg-gray-900']"
                class="h-5 text-white text-xs font-medium rounded-xl px-5 pt-0.5 inline-block">
                {{ item.type.tTitle() }}
              </div>
            </td>
            <td class="h-full bg-[#F7F7F9] ltr:border-l rtl:border-r border-gray-300 border-solid border-y text-center">
              <div class="h-full flex flex-col ltr:text-left rtl:text-right ltr:pl-3 rtl:pr-3 justify-center">
                <p class="text-sm font-medium text-gray-900">{{ $t('platform').tTitle() }}</p>
                <p class="text-base text-blue font-semibold">{{ item.platform.tUpper() }}</p>
              </div>
            </td>
            <td class="h-full bg-[#F7F7F9] ltr:border-r rtl:border-r border-gray-300 border-solid border-y text-center">
              <div class="h-full flex flex-col ltr:text-left rtl:text-right ltr:pl-3 rtl:pl-3 ltr:pr-2 rtl:pr-2 justify-center">
                <p class="text-sm font-medium text-gray-900">{{ $t('account_number') }}</p>
                <p class="text-base text-blue font-semibold">{{ item.external_id }}</p>
              </div>
            </td>
            <td class="h-full border-y border-gray-300 border-solid text-center">
              <div class="h-full flex flex-col justify-center ltr:text-left rtl:text-right ltr:pl-3 rtl:pr-3">
                <div class="flex gap-1 items-center">
                  <p class="text-sm font-medium text-gray-900">{{ $t('bonus').tTitle() }}</p>
                  <div :class="[item.account_type.toLowerCase() == 'archived' ? 'pointer-events-none' : '']"
                    class="cursor-pointer group relative flex-shrink-0">
                    <img src="../../assets/img/info.svg" width="15" />
                    <div
                      class="h-[66px] w-[215px] absolute bottom-[-332%] bg-white shadow-ts3 hidden group-hover:flex justify-center items-center rounded-lg border border-gray-300 border-solid">
                      {{ $t('cash_bonus_120') }}
                    </div>
                  </div>
                </div>
                <p class="text-base text-blue font-semibold">{{ !item.accept_bonus ? $t('no_bonus') :
                  getTABonus(item.external_id) }}</p>
              </div>
            </td>
            <td class="h-full border-y border-gray-300 border-solid ltr:text-left rtl:text-right ltr:pl-3 rtl:pr-3">
              <div class="h-full flex flex-col justify-center">
                <p class="text-sm font-medium text-gray-900">{{ $t('leverage').tTitle() }}</p>
                <p class="text-base text-blue font-semibold">1:{{ item.leverage }}</p>
              </div>
            </td>
            <td class="h-full border-y border-gray-300 border-solid ltr:text-left rtl:text-right ltr:pl-3 rtl:pr-3 ltr:pr-2 rtl:pl-2">
              <div class="h-full flex flex-col justify-center">
                <p class="text-sm font-medium text-gray-900">{{ $t('equity').tTitle() }}</p>
                <p class="text-base text-blue font-semibold">{{ $formatMoney(item.equity,
                  currencySymbols[item.currency]) }}</p>
              </div>
            </td>
            <td
              class="h-full bg-blue bg-opacity-15 ltr:border-l rtl:border-r border-gray-300 border-solid border-y ltr:text-left rtl:text-right ltr:pl-3 rtl:pr-3">
              <div class="h-full flex flex-col justify-center">
                <p class="text-sm font-medium text-gray-900">{{ $t('account_balance').tTitle() }}</p>
                <p class="text-3xl leading-10 text-blue font-bold">{{ $formatMoney(item.balance,
                  currencySymbols[item.currency]) }}</p>
              </div>
            </td>
            <td class="h-full w-[100px] px-4 2xl:px-5 bg-blue bg-opacity-15 border-y border-gray-300 border-solid">
              <Button
                mode="secondary"
                size="small"
                v-if="item.transfer_locked && item.transfer_account_external_id!='' && item.account_type!='' && item.account_type.toLowerCase()!='archived'"
                :disabled="item.account_type=='' || item.account_type.toLowerCase()=='archived'"
                customClasses="!w-[100px] !font-bold !py-1"
                @click="openTransferBackModal(item.external_id, item.equity)" >
                  {{ $t('transfer').tTitle() }}
              </Button>
              <Button v-else-if="item.account_type!='' && item.account_type.toLowerCase()!='archived'" mode="secondary" size="small" customClasses="!w-[100px] !py-1 !font-bold">
                <router-link :to="'/' + Language + '/finance'">
                  {{ $t('deposit').tTitle() }}
                </router-link>
              </Button>
            </td>
            <td
              class="h-full w-7 bg-blue bg-opacity-15 border-y ltr:border-r rtl:border-l border-gray-300 border-solid ltr:rounded-r-lg rtl:rounded-l-lg text-center m-auto ltr:pr-4 rtl:pl-4 ltr:2xl:pr-5 rtl:2xl:pl-5">
              <div class="relative w-full">
                <button v-if="item.account_type != '' && item.account_type.toLowerCase() != 'archived'"
                  type="button"
                  @click.stop="getTooltipItem(item)"
                  :id="'tooltip-button-' + item.external_id"
                  class="tooltip-icon h-7 w-7 border border-gray-600 text-gray-600 text-[27px] ltr:pl-[1px] rtl:pl-[1px] pb-[16px] border-solid bg-white rounded-full flex justify-center items-center cursor-pointer p-auto">
                  ...
                </button>
              </div>
            </td>
          </tr>
        </table>
      </div>
      <div v-if="filteredTradingAccounts.length == 0" class="text-center text-base text-blue font-semibold pb-4">
        {{ $t('no_records') }}
      </div>
      <div
        v-if="tooltipItem.visibleTooltip === true"
        :ref="'tooltip-' + tooltipItem.item.external_id"
        :id="'tooltipItem-' + tooltipItem.item.external_id"
        class="absolute z-[10] bg-white border border-gray-300 border-solid shadow-ts1 rounded-lg px-3 py-5 w-[240px] flex flex-col"
        :style="tooltipPosition"
        @click="closeActionsTooltip"
      >
        <Button v-if="tooltipItem.item.account_type_identifier != 'pamm-investor'" @click="(changeTAPassword.TAID = tooltipItem.item.external_id), (changeTAPassword.modalActive = true)" mode="primary-white" customClasses="leading-6 !font-normal !py-2 table mb-2">
            {{ $t('change_password').tTitle() }}
        </Button>
        <Button v-if="tooltipItem.item.account_type_identifier != 'pamm-investor'" mode="primary-white" customClasses="leading-6 !font-normal !py-2 table mb-2">
          <router-link :to="'/' + Language + '/trading-account/download'" @click="activeTooltip = null">
            {{ $t('platforms').tTitle() }}
          </router-link>
        </Button>
        <Button v-if="tooltipItem.item.platform == 'mt4' || tooltipItem.item.platform == 'mt5' || tooltipItem.item.platform == 'trl'" mode="primary-white" customClasses="leading-6 !font-normal !py-2 table mb-2">
          <a
            :href="[tooltipItem.item.platform=='mt4'? mt4WebTraderLinks: tooltipItem.item.platform=='mt5'? mt5WebTraderLinks:'https://live.tradelocker.com/auth/login']"
            target="_blank"
            @click="activeTooltip = null">
            {{ tooltipItem.item.platform == 'trl' ? $t('launch_tradelocker').tTitle() : $t('launch_webtrader').tTitle() }}
          </a>
        </Button>
        <Button @click="activeTooltip = null, $refs.viewTradesModal.openModal(tooltipItem.item.external_id, tooltipItem.item.platform, tooltipItem.item.type)" mode="primary-white" customClasses="leading-6 !font-normal !py-2 table">
          {{ $t('view_trades').tTitle() }}
        </Button>
        <Button
          v-if="tooltipItem.item.account_type_identifier == 'copy-trading-provider' || tooltipItem.item.account_type_identifier == 'copy-trading-follower'"
          mode="primary-white" customClasses="leading-6 !font-normal !py-2 table my-2"
          @click="(activeTooltip = null)">
          <a
            href="https://social-trading.plexytrade.com/"
            target="_blank"
            @click="activeTooltip = null">
            {{ $t('copy_trading_dashboard_link').tTitle() }}
          </a>
        </Button>
        <!-- <a
          v-if="tooltipItem.item.account_type_identifier=='pamm-investor' || tooltipItem.item.account_type_identifier=='pamm-master'"
          href="https://pamm.plexytrade.com/"
          target="_blank"
          class="w-full hover:bg-blue rounded-md text-gray-900 hover:text-white text-center appearance-none py-2 text-base leading-6 mt-2 table"
        >{{$t('pamm_dashboard').tTitle()}}</a> -->
        <Button
          mode="primary-white"
          customClasses="leading-6 !font-normal !py-2 table"
          v-if="tooltipItem.item.type === 'demo'"
          @click="activeTooltip = null, openEditDemoBalanceModal(User.info.ID, tooltipItem.item.external_id, tooltipItem.item.balance, currencySymbols[tooltipItem.item.currency])"
        >
          {{ $t('edit').tTitle() }}
        </Button>
      </div>
    </div>

    <change-password-modal v-if="changeTAPassword.modalActive"
      :TAPasswordData="changeTAPassword"></change-password-modal>

    <create-account-modal @close="closeModal" @complete="refreshTAs"
      v-show="showCreateAccountModal"></create-account-modal>

    <transfer-back-modal v-if="transferBack.modalActive" :transferBackData="transferBack" @complete="refreshTAs">
    </transfer-back-modal>

    <view-trades-modal ref="viewTradesModal"></view-trades-modal>

    <edit-demo-balance-modal
      v-if="editDemoBalance.modalActive"
      :data="editDemoBalance.data"
      @complete="refreshTAs"
      @close="editDemoBalance.modalActive = false"
    >
    </edit-demo-balance-modal>

  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { service } from '../../main.js'
import config from '../../config'
import api from '../../api'
import moment from 'moment'
import ViewTradesModal from '../../components/ViewTradesModal.vue'
import ChangePasswordModal from '../../components/ChangePasswordModal.vue'
import CreateAccountModal from '../../components/CreateAccountModal.vue'
import TransferBackModal from '../../components/TransferBackModal.vue'
import EditDemoBalanceModal from '../../components/EditDemoBalanceModal.vue'
import links from '@/config/links.js'
import Button from '@/components/reusableComponents/Button.vue'
import ButtonGroup from '@/components/reusableComponents/ButtonGroup.vue'
import Select from '@/components/reusableComponents/Select.vue'

export default {
  components: {
    ViewTradesModal,
    ChangePasswordModal,
    CreateAccountModal,
    TransferBackModal,
    EditDemoBalanceModal,
    Button,
    ButtonGroup,
    Select,
  },
  props: ['platformImages'],
  data() {
    return {
      filteredTradingAccounts: [],
      selectedPlatform: 'all',
      selectedAccountType: 'all',
      active: false,
      showCreateAccountModal: false,
      name: 'Account list',
      tabsActive: 'openTrades',
      dateFrom: moment(moment().subtract(6, 'months')).format('YYYY-MM-DD'),
      dateTo: moment().format('YYYY-MM-DD'),
      prevFrom: moment(moment().subtract(6, 'months')).format('YYYY-MM-DD'),
      prevTo: moment().format('YYYY-MM-DD'),
      tradesModalTAID: 0,
      tradesModalPlatform: '',
      tradesModalType: '',
      trades: [],
      prevTrades: [],
      sums: [],
      prevSums: [],
      translations: {
        text: {
          currentPassword: this.$t('current_password').tTitle(),
          newPassword: this.$t('new_password').tTitle(),
          newPasswordConfirm: this.$t('confirm_new_password').tTitle(),
        },
      },
      changeTAPassword: {
        modalActive: false,
        new: '',
        newConfirm: '',
        TAID: null,
      },
      transferBack: {
        modalActive: false,
        amount: 0,
        equity: 0,
        TAID: 0,
      },
      editDemoBalance: {
        modalActive: false,
        data: {
          userID: '',
          TAID: '',
          balance: '',
          prefix: '',
        },
      },
      currencySymbols: config.currencies,
      websiteURL: config.URL.website,
      selectedView: 'list',
      platforms: [
        { value: 'all', label: this.$t('platform').tTitle() },
        { value: 'mt4', label: 'MT4' },
        { value: 'mt5', label: 'MT5' },
        { value: 'trl', label: 'Tradelocker' },
      ],
      tooltipItem: {
        visibleTooltip: false,
        item: null,
      },
      tooltipPosition: {},
      activeMobileTooltip: null,
      showCopyTradingAttachedToTooltip: false,
    }
  },
  computed: {
    ...mapGetters({
      Language: 'language/code',
      User: 'user/all',
      Requests: 'requests/all',
      logoLoaderActive: 'logoLoader/active',
      UserInfo: 'user/info',
      Bonuses: 'bonusconfig/bonusData',
      TA: 'user/TA',
    }),
    mt4WebTraderLinks() {
      return links.getLink('mt4WebTrader', 'en')
    },
    mt5WebTraderLinks() {
      return links.getLink('mt5WebTrader', 'en')
    },
  },
  watch: {
    selectedPlatform() {
      this.filterAccounts()
      this.$bus.$emit('InnerRouteChange')
    },
    selectedAccountType() {
      this.filterAccounts()
      this.$bus.$emit('InnerRouteChange')
    },
    tabsActive() {
      this.changeTab()
    },
    'User.info'(u) {
      if (u.ID) {
        api.GetTradingAccounts().then(res => {
          this['user/setTA'](res.data.TAs)
          this.filterAccounts()
        })
      }
    },
    'changeTAPassword.modalActive'(v) {
      if (v === true) {
        this.disableScroll()
      } else {
        this.enableScroll()
      }
    },
    showCreateAccountModal(value) {
      if (value === true) {
        this.disableScroll()
      } else {
        this.enableScroll()
      }
    },
    // watcher for the i18n language change
    '$i18n.locale'() {
      this.$validator.reset()
    },
  },
  created() {
    window.addEventListener('resize', this.setDefaultView)
    this.filterAccounts()
  },
  mounted() {
    // set selectedView as Grid when the device is mobile.
    this.setDefaultView()

    this.$bus.$on('AppClick', this.onAppClick)
    // // load TA
    // if (typeof this.User.info.ID !== 'undefined') {
    //   this['logoLoader/set'](true)
    //   api.GetTradingAccounts().then(() => {
    //     this.filterAccounts()
    //     this['logoLoader/set'](false)
    //   })
    // }
    // this['logoLoader/set'](true)
    api.GetBonusData().then(bonus => {
      this['bonusconfig/setBonusData'](bonus)
    })
    api
      .GetTradingAccounts()
      .then(res => {
        this['user/setTA'](res.data.TAs)
        this.filterAccounts()
        // this['logoLoader/set'](false)
      })
      .catch(() => {
        // this['logoLoader/set'](false)
      })
    this.dragContainer('#taListContainer')

    document.addEventListener('click', this.closeTooltip)
    window.addEventListener('resize', this.closeTooltip)
    window.addEventListener('scroll', this.closeTooltip, true)
    window.addEventListener('keydown', this.closeTooltip)
  },
  beforeDestroy() {
    this.$bus.$off('AppClick', this.onAppClick)
    // this.$parent.$el.removeEventListener('click', this.onAppClick)

    document.removeEventListener('click', this.closeTooltip)
    window.removeEventListener('resize', this.closeTooltip)
    window.removeEventListener('scroll', this.closeTooltip, true)
    window.removeEventListener('keydown', this.closeTooltip)
  },
  methods: {
    filterAccounts() {
      this.filteredTradingAccounts = []

      for (let i = 0; i < this.TA?.length; i++) {
        const account = this.TA[i]

        if (
          (account.platform === this.selectedPlatform || this.selectedPlatform === 'all') &&
          (account.type === this.selectedAccountType || this.selectedAccountType === 'all') &&
          this.TA[i]?.platform != 'transfer' &&
          account.status_enabled
        ) {
          if (account.platform === 'trl') {
            // check if the string has ('-')
            const hasDash = account.account_type.includes('-')
            if (hasDash) {
              // Extract the leverage and account_type and split them
              const spiltString = account.account_type.split('-')
              const leverage = parseInt(account.account_type.split('-').pop())
              const accountType = spiltString[0]

              // Dynamically update the leverage and modify the account_type
              account.leverage = leverage
              account.account_type = accountType
            }
          }

          this.filteredTradingAccounts.push(account)
        }
      }
    },
    showActionsTooltip(ta) {
      this.activeMobileTooltip = this.activeMobileTooltip === ta ? null : ta
    },
    getTooltipItem(item) {
      if (this.tooltipItem && this.tooltipItem.item && this.tooltipItem.item.external_id === item.external_id) {
        this.tooltipItem.visibleTooltip = !this.tooltipItem.visibleTooltip
        this.clearDesktopTooltip()
      } else {
        this.tooltipItem = { item: item, visibleTooltip: true }
      }

      if (this.tooltipItem.visibleTooltip) {
        this.$nextTick(() => {
          this.setPosition(item)
        })
      }
    },
    setPosition(item) {
      this.tooltipPosition = {}
      const button = document.getElementById(`tooltip-button-${item.external_id}`)
      const container = document.getElementById('taListContainer')
      if (!button || !container) return

      const rect = button.getBoundingClientRect()
      const rectContainer = container.getBoundingClientRect()
      const top = rect.top + window.scrollY - 178
      const right = rectContainer.right - rect.right + 33
      const left = rectContainer.left - rect.left + 67

      this.tooltipPosition = {
        [this.Language === 'fa' ? 'left' : 'right']: `${this.Language === 'fa' ? left : right}px`,
        top: `${top}px`,
      }
    },
    closeTooltip(event) {
      if (this.tooltipItem && this.tooltipItem.visibleTooltip) {
        if (!event || event.type === 'resize' || event.type === 'scroll' || (event.type === 'keydown' && event.key === 'Tab')) {
          this.clearDesktopTooltip()
          return
        }

        if (event.type === 'click') {
          const id = this.tooltipItem && this.tooltipItem.item ? this.tooltipItem.item.external_id : null
          if (id) {
            const tooltip = document.getElementById(`tooltipItem-${id}`)
            const button = document.getElementById(`tooltip-button-${id}`)
            const clickedInsideTooltip = tooltip && tooltip.contains(event.target)
            const clickedInsideButton = button && button.contains(event.target)

            if (!clickedInsideTooltip && !clickedInsideButton) {
              this.clearDesktopTooltip()
            }
          }
        }
      }

      if (event && event.type === 'click' && this.activeMobileTooltip !== null) {
        const tooltips = Array.from(document.getElementsByClassName('actions-tooltip'))
        const icons = Array.from(document.getElementsByClassName('tooltip-icon'))
        const clickedInsideTooltip = tooltips.some(el => el.contains(event.target))
        const clickedOnIcon = icons.some(el => el.contains(event.target))

        if (!clickedInsideTooltip && !clickedOnIcon) {
          this.activeMobileTooltip = null
        }
      }
    },
    clearDesktopTooltip() {
      if (!this.tooltipItem) return

      this.tooltipItem.visibleTooltip = false
      this.tooltipItem.item = null
      this.tooltipPosition = {}
    },
    closeActionsTooltip() {
      this.activeMobileTooltip = null
      this.clearDesktopTooltip()
    },
    openTransferBackModal(TAID, equity) {
      this.transferBack.modalActive = true
      this.transferBack.TAID = TAID
      this.transferBack.equity = equity
    },
    changeTAPasswordReq() {
      // validate
      // this['logoLoader/set'](true)
      this.$validator
        .validateAll('form-changePassword')
        .then(result => {
          if (!result) {
            // this['logoLoader/set'](false)
          } else {
            service
              .post('/ta/change-password', {
                TAID: this.changeTAPassword.TAID,
                userID: this.User.info.ID,
                password: this.changeTAPassword.new,
                passwordConfirm: this.changeTAPassword.newConfirm,
              })
              .then(() => {
                this.closeChangePasswordModal()
                // this['logoLoader/set'](false)

                this.$toasted.success(this.$t('success'))
              })
              .catch(error => {
                this.closeChangePasswordModal()
                // this['logoLoader/set'](false)

                if (typeof error.response.data !== 'undefined') {
                  this.$toasted.error(this.$t(error.response.data.meta.messageID) + '<span class="error-id">' + error.response.data.id + '</span>')
                }
              })
          }
        })
        .catch(() => {
          // this['logoLoader/set'](false)
        })
    },
    getTABonus(ta) {
      let amount = 0
      for (let i = 0; i < this.Bonuses.length; i++) {
        if (this.Bonuses[i].trading_account === ta) {
          if (this.Bonuses[i].status === 'granted') {
            return this.Bonuses[i].bonusAmount
          }
          amount = this.Bonuses[i].bonusAmount
        }
      }
      return amount
    },
    preSelecteDepositTA() {
      // might want to pre-select psp here
      this.$router.push('/' + this.Language + '/finance')
    },
    changeTab() {
      let tempFrom, tempTo, tempTrades, tempSums

      tempFrom = this.dateFrom
      tempTo = this.dateTo
      tempTrades = this.trades
      tempSums = this.sums

      this.dateFrom = this.prevFrom
      this.dateTo = this.prevTo
      this.trades = this.prevTrades
      this.sums = this.prevSums

      this.prevFrom = tempFrom
      this.prevTo = tempTo
      this.prevTrades = tempTrades
      this.prevSums = tempSums
    },
    timestampToDate(t) {
      return moment.utc(moment.unix(t)).format('YYYY-MM-DD HH:mm')
    },
    imagePath() {
      // return require('../../assets/img/logos/' + platform + '-small.png')
    },
    toggleSettingsActive(e) {
      // rest of settings
      let el = document.getElementsByClassName('settings')
      for (let i = 0; i < el.length; i++) {
        if (el[i] !== e.target.parentElement) {
          el[i].classList.remove('is-active')
        }
      }
      // row
      let par = e.target.parentElement
      while (par.tagName !== 'TR') {
        par = par.parentElement
        if (par === null) {
          break
        }
      }
      // rest of rows
      let trs = document.getElementById('tas')?.getElementsByTagName('tr') || []
      for (let i = 0; i < trs.length; i++) {
        if (trs[i] !== par) {
          trs[i].classList.remove('selected')
        }
      }
      // target
      e.target.parentElement.classList.toggle('is-active')

      par.classList.toggle('selected')
    },
    onAppClick(e) {
      if (!e.target.parentElement.classList.contains('settings')) {
        let trs = document.getElementById('tas')?.getElementsByTagName('tr') || []
        for (let i = 0; i < trs.length; i++) {
          trs[i].classList.remove('selected')
        }
        let el = document.getElementsByClassName('settings')
        for (let i = 0; i < el.length; i++) {
          el[i].classList.remove('is-active')
        }
      }
    },
    closeChangePasswordModal() {
      this.changeTAPassword.modalActive = false
      this.changeTAPassword.TAID = null
      this.changeTAPassword.new = ''
      this.changeTAPassword.newConfirm = ''
      this.errors.clear()
      this.$nextTick(() => {
        this.$validator.reset()
      })
    },
    closeModal() {
      this.showCreateAccountModal = false
      document.getElementById('CAcontainer').classList.add('translate-x-full')
    },
    refreshTAs() {
      api.GetTradingAccounts().then(() => {
        this.filterAccounts()
      })
    },
    showCAModal() {
      this.showCreateAccountModal = true
      setTimeout(() => document.getElementById('CAcontainer').classList.remove('translate-x-full'), 10)
    },
    setDefaultView() {
      if (window.innerWidth < 1180) {
        this.selectedView = 'grid'
      } else {
        this.selectedView = 'list'
      }
      // reset activeTooltip when view changes
      this.clearDesktopTooltip()
      this.activeMobileTooltip = null
    },
    disableScroll() {
      document.querySelector('body').classList.add('overflow-hidden')
    },
    enableScroll() {
      document.querySelector('body').classList.remove('overflow-hidden')
    },
    getItemImage(item) {
      if (item.type === 'demo') {
      return item.account_type_identifier ?  require(`../../assets/img/demo.svg`) : require(`../../assets/img/archived.svg`)
      }
      const accountTypeImages = {
        silver: 'silver',
        'gold-ecn': 'gold',
        'gold-raw': 'gold',
        'silver-islamic': 'silver-islamic',
        'platinum-vip': 'platinum',
        micro: 'micro',
        'pamm-investor': 'pamm-investor',
        'pamm-master': 'pamm-investor',
        'no-deposit-bonus': 'no-deposit-bonus',
        'gold-raw-is': 'islamic',
        'raw-bonus': 'raw-bonus',
        'trading-competition': 'trading-competition',
        'copy-trading-follower': 'copy-trading-follower',
        'copy-trading-provider': 'copy-trading-provider',
      }
      return accountTypeImages[item.account_type_identifier] ? require(`../../assets/img/${accountTypeImages[item.account_type_identifier]}.svg`) : require(`../../assets/img/archived.svg`)
    },
    openEditDemoBalanceModal(userID, TAID, balance, prefix) {
      this.editDemoBalance.modalActive = true
      this.editDemoBalance.data = {
        userID: userID,
        TAID: TAID,
        balance: balance,
        prefix: prefix,
      }
    },
    ...mapActions(['logoLoader/set', 'errorModal/set', 'user/setTA', 'bonusconfig/setBonusData']),
  },
}
</script>
<style lang="css">
.noUserSelect {
  -webkit-user-select: none;
  -webkit-user-drag: none;
  -webkit-app-region: no-drag;
}
#taListContainer::-webkit-scrollbar {
  height: 4px;
  width: 4px;
}
/* Track */
#taListContainer::-webkit-scrollbar-track {
  background: #e9edf4;
  border-radius: 12px;
}
/* Handle */
#taListContainer::-webkit-scrollbar-thumb {
  background: #2b63e3;
  border-radius: 12px;
}

#taListContainer {
  scroll-behavior: smooth;
}

#taListContainer.active {
  scroll-behavior: auto;
}
</style>
